import { Mapper } from '../base-mapper';
import { Category, SubCategory } from '@/core/domain/owas-report';
import { GetCategoriesDTO, SubCategoryDTO } from '@/core/dto/owas-report';

export class GetCategoriesMapper implements Mapper<Category[]> {
	private readonly data: GetCategoriesDTO[];

	constructor(data: GetCategoriesDTO[]) {
		this.data = data;
	}

	toTransformSubCategory(value: SubCategoryDTO): SubCategory {
		return new SubCategory({
			id: value.id,
			name: value.name,
			description: value.description,
			value: value.value,
			owas_category_id: value.owas_category_id
		});
	}

	toTransform(value: GetCategoriesDTO): Category {
		return new Category({
			id: value.id,
			name: value.name,
			description: value.description,
			sub_categories: value.sub_categories.map(this.toTransformSubCategory.bind(this))
		});
	}

	toDomain(): Category[] {
		return this.data.map(this.toTransform.bind(this));
	}
}
